export default {
  lang: 'pt-BR',
  dir: 'ltr',
  common: {
    ok: 'OK',
    cancel: 'Cancelar',
    key_backspace: 'Tecla backspace',
    key_del: 'Tecla delete',
    key_down: 'Seta para baixo',
    key_up: 'Seta para cima',
    more_opts: 'Mais opções',
    url: 'URL',
    width: 'Largura',
    height: 'Altura'
  },
  misc: {
    powered_by: 'Tecnologia'
  },
  ui: {
    toggle_stroke_tools: 'Mais opções de traço',
    palette_info: 'Click para mudar a cor de preenchimento, shift-click para mudar a cor do traço',
    zoom_level: 'Mudar zoom',
    panel_action: 'Click to open side panel',
    quality: 'Quality:',
    pathNodeTooltip: 'Drag node to move it. Double-click node to change segment type',
    pathCtrlPtTooltip: 'Drag control point to adjust curve properties',
    pick_stroke_paint_opacity: 'Pick a Stroke Paint and Opacity',
    pick_fill_paint_opacity: 'Pick a Fill Paint and Opacity',
    group_identify_label: 'Group identification label',
    export_type_label: 'Select an image type for export:'
  },
  properties: {
    id: 'Identifica o elemento',
    fill_color: 'Mudar a cor de preenchimento',
    stroke_color: 'Mudar a cor do traço',
    stroke_style: 'Mudar o estilo do traço',
    stroke_width: 'Mudar a espessura do traço em 1, shift-click para mudar 0.1',
    pos_x: 'Mudar a coordenada X',
    pos_y: 'Mudar a coordenada Y',
    linecap_butt: 'Estilo do fim do traço: Topo',
    linecap_round: 'Estilo do fim do traço: Redondo',
    linecap_square: 'Estilo do fim do traço: Quadrado',
    linejoin_bevel: 'Estilo da Aresta: Chanfro',
    linejoin_miter: 'Estilo da Aresta: Reto',
    linejoin_round: 'Estilo da Aresta: Redondo',
    angle: 'Mudar ângulo de rotação',
    blur: 'Mudar valor de desfoque',
    opacity: 'Mudar opacidade do item selecionado',
    circle_cx: 'Mudar a coordenada cx do círculo',
    circle_cy: 'Mudar a coordenada cy do círculo',
    circle_r: 'Mudar o raio do círculo',
    ellipse_cx: 'Mudar a coordenada cx da elípse',
    ellipse_cy: 'Mudar a coordenada cy da elípse',
    ellipse_rx: 'Mudar o raio x da elípse',
    ellipse_ry: 'Mudar o raio y da elípse',
    line_x1: 'Mudar a coordenada x do início da linha',
    line_x2: 'Mudar a coordenada x do fim da linha',
    line_y1: 'Mudar a coordenada y do início da linha',
    line_y2: 'Mudar a coordenada y do fim da linha',
    rect_height: 'Mudar a altura do retângulo',
    rect_width: 'Mudar a largura do retângulo',
    corner_radius: 'Mudar o raio da aresta do retângulo',
    image_width: 'Mudar a largura da imagem',
    image_height: 'Mudar a altura da imagem',
    image_url: 'Mudar URL',
    node_x: 'Mudar a coordenada x da aresta',
    node_y: 'Mudar a coordenada y da aresta',
    seg_type: 'Mudar o tipo de segmento',
    straight_segments: 'Reto',
    curve_segments: 'Curvo',
    text_contents: 'Mudar conteúdo do texto',
    font_family_label: 'Font:',
    font_family: 'Mudar o estilo da fonte',
    font_size: 'Mudar o tamanho da fonte',
    bold: 'Negrito',
    text_decoration_underline: 'Underline',
    text_decoration_linethrough: 'Line-Through',
    text_decoration_overline: 'Overline',
    italic: 'Italico',
    text_anchor_start: 'Align the text in start',
    text_anchor_middle: 'Align the text in middle',
    text_anchor_end: 'Align the text in end',
    text_letter_spacing: 'Change the letter spacing',
    text_word_spacing: 'Change the word spacing',
    text_length: 'Lets you specify the width of the space into which the text will draw',
    text_length_adjust: 'Length adjust',
    text_length_adjust_spacing: 'Spacing',
    text_length_adjust_spacing_and_glyphs: 'Spacing & Glyphs',
    class: 'Element class',
    serif: 'Serif',
    sans_serif: 'Sans-serif',
    cursive: 'Cursive',
    fantasy: 'Fantasy',
    monospace: 'Monospace',
    courier: 'Courier',
    helvetica: 'Helvetica',
    times: 'times',
    prefs_and_content: 'Store preferences and SVG content locally',
    prefs_only: 'Only store preferences locally',
    no_prefs_or_content: 'Do not store my preferences or SVG content locally',
    jgraduate_pad: 'Pad',
    jgraduate_reflect: 'Reflect',
    jgraduate_repeat: 'Repeat'
  },
  tools: {
    main_menu: 'Menu Principal',
    bkgnd_color_opac: 'Mudar cor/opacidade do fundo',
    connector_no_arrow: 'Sem flecha',
    fitToContent: 'Ajustar ao conteúdo',
    fit_to_all: 'Ajustar a todo conteúdo',
    fit_to_canvas: 'Ajustar à tela',
    fit_to_layer_content: 'Ajustar ao conteúdo da camada',
    fit_to_sel: 'Ajustar à seleção',
    align_relative_to: 'Alinhar em relação à ...',
    relativeTo: 'Referência:',
    page: 'página',
    largest_object: 'maior objeto',
    selected_objects: 'objetos selecionados',
    smallest_object: 'menor objeto',
    new_doc: 'Nova imagem',
    open_doc: 'Abrir imagem',
    export_img: 'Export',
    save_doc: 'Salvar imagem',
    import_doc: 'Importar SVG',
    align_to_page: 'Alinhar elemento na página',
    align_bottom: 'Alinhar no fundo',
    align_center: 'Alinhar no centro',
    align_left: 'Alinhar na esquerda',
    align_middle: 'Alinhar no meio',
    align_right: 'Alinhar na direita',
    align_top: 'Alinhar no topo',
    mode_select: 'Selecão',
    mode_fhpath: 'Lápis',
    mode_line: 'Linha',
    mode_rect: 'Retângulo',
    mode_square: 'Quadrado',
    mode_fhrect: 'Retângulo a mão-livre',
    mode_ellipse: 'Elípse',
    mode_circle: 'Círculo',
    mode_fhellipse: 'Elípse a mão-livre',
    mode_path: 'Contorno',
    mode_text: 'Texto',
    mode_image: 'Imagem',
    mode_zoom: 'Zoom',
    no_embed: 'Atenção: Esta imagem não pode ser incorporada e dependerá de seu caminho para ser exibida',
    undo: 'Desfazer',
    redo: 'Refazer',
    tool_source: 'Editar o código',
    wireframe_mode: 'Modo linhas',
    clone: 'Clonar Elemento(s)',
    del: 'Deletar Elemento(s)',
    group_elements: 'Agrupar Elementos',
    make_link: 'Criar (hyper)link',
    set_link_url: 'Alterar URL (em branco para remover)',
    to_path: 'Converter para Contorno',
    reorient_path: 'Reorientar contorno',
    ungroup: 'Desagrupar Elementos',
    docprops: 'Propriedades',
    editor_homepage: 'SVG-Edit Home Page',
    move_bottom: 'Mover para o fundo',
    move_top: 'Mover para o topo',
    node_clone: 'Clonar Aresta',
    node_delete: 'Deletar Aresta',
    node_link: 'Alinhar pontos de controle',
    add_subpath: 'Adicionar contorno',
    openclose_path: 'Abrir/Fechar contorno',
    source_save: 'Salvar',
    cut: 'Recortar',
    copy: 'Copiar',
    paste: 'Colar',
    paste_in_place: 'Colar no mesmo local',
    delete: 'Deletar',
    group: 'Agrupar',
    move_front: 'Trazer para Frente',
    move_up: 'Avançar',
    move_down: 'Recuar',
    move_back: 'Enviar para Trás',
    tool_unlink_use: 'Break link to reference element (make unique)',
    ellipse_circle_tool: 'Ellipse/Circle Tool',
    square_rect_tool: 'Square/Rect Tool',
    remember_this_choice: 'Remember this choice?',
    remember_this_choice_title: 'If you choose to opt out of storage while remembering this choice, the URL will change so as to avoid asking again.'
  },
  layers: {
    layer: 'Camada',
    layers: 'Camadas',
    del: 'Deletar Camada',
    move_down: 'Enviar Camada para Trás',
    new: 'Nova Camada',
    rename: 'Renomear Camada',
    move_up: 'Trazer Camada para Frente',
    dupe: 'Duplicar Camada',
    merge_down: 'Achatar para baixo',
    merge_all: 'Achatar todas',
    move_elems_to: 'Mover elementos para:',
    move_selected: 'Mover elementos selecionados para outra camada'
  },
  config: {
    image_props: 'Propriedades',
    doc_title: 'Título',
    doc_dims: 'Dimensões',
    included_images: 'Imagens',
    image_opt_embed: 'Incorporadas (arquivos locais)',
    image_opt_ref: 'Usar referência',
    editor_prefs: 'Preferências',
    language: 'Idioma',
    background: 'Fundo da página',
    editor_img_url: 'URL da Imagem',
    editor_bg_note: 'Atenção: Fundo da página não será salvo.',
    select_predefined: 'Modelos:',
    units_and_rulers: 'Unidade & Réguas',
    show_rulers: 'Mostrar réguas',
    base_unit: 'Unidade base:',
    grid: 'Grade',
    snapping_onoff: 'Snap on/off',
    snapping_stepsize: 'Intensidade do Snap:',
    grid_color: 'Grid color',
    done: 'Done',
    change_xxx_color: 'Change xxx color',
    pick_paint_opavity: 'Pick a {{newValue}} Paint and Opacity',
    open_color_picker: 'Click To Open Color Picker',
    jpicker_title: 'Drag Markers To Pick A Color',
    jpicker_new_color: 'new',
    jpicker_current_color: 'current',
    jpicker_tooltip_colors_new_color: 'New Color - Press &ldquo;OK&rdquo; To Commit',
    jpicker_tooltip_colors_current_color: 'Click To Revert To Original Color',
    jpicker_tooltip_buttons_ok: 'Commit To This Color Selection',
    jpicker_tooltip_buttons_cancel: 'Cancel And Revert To Original Color',
    jpicker_tooltip_hue_radio: 'Set To &ldquo;Hue&rdquo; Color Mode',
    jpicker_tooltip_hue_textbox: 'Enter A &ldquo;Hue&rdquo; Value (0-360&deg;)',
    jpicker_tooltip_saturation_radio: 'Set To &ldquo;Saturation&rdquo; Color Mode',
    jpicker_tooltip_saturation_textbox: 'Enter A &ldquo;Saturation&rdquo; Value (0-100%)',
    jpicker_tooltip_value_radio: 'Set To &ldquo;Value&rdquo; Color Mode',
    jpicker_tooltip_value_textbox: 'Enter A &ldquo;Value&rdquo; Value (0-100%)',
    jpicker_tooltip_red_radio: 'Set To &ldquo;Red&rdquo; Color Mode',
    jpicker_tooltip_red_textbox: 'Enter A &ldquo;Red&rdquo; Value (0-255)',
    jpicker_tooltip_green_radio: 'Set To &ldquo;Green&rdquo; Color Mode',
    jpicker_tooltip_green_textbox: 'Enter A &ldquo;Green&rdquo; Value (0-255)',
    jpicker_tooltip_blue_radio: 'Set To &ldquo;Blue&rdquo; Color Mode',
    jpicker_tooltip_blue_textbox: 'Enter A &ldquo;Blue&rdquo; Value (0-255)',
    jpicker_tooltip_alpha_radio: 'Set To &ldquo;Alpha&rdquo; Color Mode',
    jpicker_tooltip_alpha_textbox: 'Enter A &ldquo;Alpha&rdquo; Value (0-100)',
    jpicker_tooltip_hex_textbox: 'Enter A &ldquo;Hex&rdquo; Color Value (#000000-#ffffff)',
    jpicker_tooltip_hex_alpha: 'Enter A &ldquo;Alpha&rdquo; Value (#00-#ff)',
    jgraduate_solid_color: 'Solid Color',
    jgraduate_linear_gradient: 'Linear Gradient',
    jgraduate_radial_gradient: 'Radial Gradient',
    jgraduate_begin_point: 'Begin Point',
    jgraduate_enter_starting_x: 'Enter starting x value between 0.0 and 1.0',
    jgraduate_enter_starting_y: 'Enter starting y value between 0.0 and 1.0',
    jgraduate_end_point: 'End Point',
    jgraduate_enter_ending_x: 'Enter ending x value between 0.0 and 1.0',
    jgraduate_enter_ending_y: 'Enter ending y value between 0.0 and 1.0',
    jgraduate_center_point: 'Center Point',
    jgraduate_enter_value_x: 'Enter x value between 0.0 and 1.0',
    jgraduate_enter_value_y: 'Enter y value between 0.0 and 1.0',
    jgraduate_focal_point: 'Focal Point',
    jgraduate_match_center: 'Match center:',
    jgraduate_enter_focal_x: 'Enter x value between 0.0 and 1.0',
    jgraduate_enter_focal_y: 'Enter y value between 0.0 and 1.0',
    jgraduate_spread_method: 'Spread method',
    jgraduate_radius: 'Radius:',
    jgraduate_set_radius: 'Click to set radius',
    jgraduate_ellip: 'Ellip:',
    jgraduate_set_ellip: 'Click to set Ellip',
    jgraduate_angle: 'Angle:',
    jgraduate_set_angle: 'Click to set Angle',
    jgraduate_deg: 'deg:',
    jgraduate_opac: 'Opac:',
    jgraduate_set_opac: 'Click to set Opac'
  },
  notification: {
    invalidAttrValGiven: 'Valor inválido',
    noContentToFitTo: 'Não há conteúdo',
    dupeLayerName: 'Nome duplicado',
    enterUniqueLayerName: 'Insira um nome único',
    enterNewLayerName: 'Insira um novo nome',
    layerHasThatName: 'A camada já pussui este nome',
    QmoveElemsToLayer: 'Mover elementos selecionados para a camada: \'%s\'?',
    QwantToClear: 'Deseja criar um novo arquivo?\nO histórico também será apagado!',
    QwantToOpen: 'Deseja abrir um novo arquivo?\nO histórico também será apagado!',
    QerrorsRevertToSource: 'Foram encontrados erros ná análise do código SVG.\nReverter para o código SVG original?',
    QignoreSourceChanges: 'Ignorar as mudanças no código SVG?',
    featNotSupported: 'Recurso não suportado',
    enterNewImgURL: 'Insira nova URL da imagem',
    defsFailOnSave: 'Atenção: Devido a um bug em seu navegador, esta imagem pode apresentar erros, porém será salva corretamente.',
    loadingImage: 'Carregando imagem, por favor aguarde...',
    saveFromBrowser: "Select 'Save As...' in your browser (possibly via file menu or right-click context-menu) to save this image as a {{type}} file.",
    noteTheseIssues: 'Atenção para as seguintes questões: ',
    unsavedChanges: 'Existem alterações não salvas.',
    enterNewLinkURL: 'Insira novo URL do hyperlink',
    errorLoadingSVG: 'Erro: Impossível carregar dados SVG',
    URLLoadFail: 'Impossível carregar deste URL',
    retrieving: 'Retrieving \'%s\' ...',
    popupWindowBlocked: 'Popup window may be blocked by browser',
    exportNoBlur: 'Blurred elements will appear as un-blurred',
    exportNoforeignObject: 'foreignObject elements will not appear',
    exportNoDashArray: 'Strokes will appear filled',
    exportNoText: 'Text may not appear as expected',
    editorPreferencesMsg: 'By default and where supported, SVG-Edit can store your editor preferences and SVG content locally on your machine so you do not need to add these back each time you load SVG-Edit. If, for privacy reasons, you do not wish to store this information on your machine, you can change away from the default option below.',
    source_dialog_note: 'Copy the contents of this box into a text editor, then save the file with a .svg extension.'
  }
}
